/**
 * Course identity, and nothing else.
 *
 * The six hues appear only here and as the stripe on a card. They are never a
 * fill and never text colour, because the moment a course hue carries meaning
 * it starts competing with the semantic colours that actually do.
 */
export function CourseDot({ colorIndex, size = 8 }: { colorIndex: number; size?: number }) {
  return (
    <span
      aria-hidden
      className="inline-block shrink-0 rounded-full"
      style={{ width: size, height: size, backgroundColor: `var(--course-${colorIndex % 6})` }}
    />
  )
}

export function CourseStripe({ colorIndex }: { colorIndex: number }) {
  return (
    <span
      aria-hidden
      className="absolute inset-y-0 left-0 w-[3px] rounded-l-[var(--radius)]"
      style={{ backgroundColor: `var(--course-${colorIndex % 6})` }}
    />
  )
}
